import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerLeftDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-corner-left-down"><path d="M19.25 2.75H8.75V18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 15.5L8.75 19.5L4.75 15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowCornerLeftDown;
